<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('promotionConditionsChangedDialog.title')"
    [acceptText]="t('promotionConditionsChangedDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('promotionConditionsChangedDialog.description') }}</p>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
